module.exports = __webpack_public_path__ + "img/brand.7712d4b4.png";